import React, { useEffect, useState } from 'react';
import Layout from '../components/navbar/Layout';
import TabComponent from '../components/TabComponent'; // TabComponent 경로를 수정해주세요
import NoticeTab1 from '../components/notice/NoticeTab1';
import NoticeTab2 from '../components/notice/NoticeTab2';
import { useLocation, useNavigate } from 'react-router-dom';
import { NoticePageUrl } from '../url/poenUrl';
import LoginRedirect from '../components/LoginRedirect';

function NoticePage() {
  const [activeTab, setActiveTab] = useState<number>(0);
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 데이터 정의
  const tabs = [
    {
      title: '공지사항',
      content: <NoticeTab1 />,
    },
    {
      title: '문의 게시판',
      content: <NoticeTab2 />,
    },
  ];

  // activeTab 값을 URL 쿼리에서 읽어오기
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const activeTabFromUrl = parseInt(queryParams.get('activeTab') || '0', 10);
    setActiveTab(activeTabFromUrl);
  }, [location.search]);

  const handleTabChange = (index: number) => {
    // activeTab에 따라 URL을 다르게 설정

    navigate(`${NoticePageUrl}?activeTab=${index}`);
  };

  return (
    <Layout>
      <LoginRedirect />
      <TabComponent
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </Layout>
  );
}

export default NoticePage;
